import type { AiProvider } from "./types";

export interface ProviderPreset {
  id: AiProvider;
  label: string;
  baseUrl: string;
  model: string;
  hint: string;
}

export const PROVIDER_PRESETS: ProviderPreset[] = [
  {
    id: "deepseek",
    label: "DeepSeek",
    baseUrl: "https://api.deepseek.com",
    model: "deepseek-chat",
    hint: "官方 OpenAI-compatible 接口",
  },
  {
    id: "openai",
    label: "OpenAI",
    baseUrl: "https://api.openai.com/v1",
    model: "",
    hint: "填写账户当前可用的模型 ID",
  },
  {
    id: "openrouter",
    label: "OpenRouter",
    baseUrl: "https://openrouter.ai/api/v1",
    model: "",
    hint: "统一访问多家模型，填写完整 model slug",
  },
  {
    id: "siliconflow",
    label: "SiliconFlow",
    baseUrl: "https://api.siliconflow.cn/v1",
    model: "",
    hint: "填写控制台中可用的模型 ID",
  },
  {
    id: "ollama",
    label: "本地 Ollama",
    baseUrl: "http://localhost:11434/v1",
    model: "",
    hint: "无需云端 key；浏览器需允许访问本地端点",
  },
  {
    id: "custom",
    label: "自定义",
    baseUrl: "",
    model: "",
    hint: "任意支持 /chat/completions 的兼容服务",
  },
];

export function providerLabel(provider: AiProvider) {
  return PROVIDER_PRESETS.find((item) => item.id === provider)?.label || "自定义";
}
